import { gql } from '@apollo/client';

export const getAllMobileLanguage = gql`query getAllMobileLanguage($currentPage: Int, $appType: String, $searchList: String, $isEnable:Boolean) {
    getAllMobileLanguage(currentPage: $currentPage, appType: $appType, searchList: $searchList, isEnable:$isEnable) {
      count
      results {
        id
        language
        languageCode
        isActive
        isEnable
      }
      status
      errorMessage
    }
  }  
`;

export const updateDefaultLanguage = gql`mutation updateDefaultLanguage($id: Int!) {
    updateDefaultLanguage(id: $id) {
      status
      errorMessage
    }
  }  
`;

export const updateLanguageStatus = gql`mutation updateLanguageStatus($id: Int!, $isEnable: Boolean) {
    updateLanguageStatus(id: $id, isEnable: $isEnable) {
      status
      errorMessage
    }
  }  
`;


export const getAvailableLanguages = gql`query getAvailableLanguages( $appType: String) {
  getAvailableLanguages( appType: $appType) {
    results {
      languageCode
    }
    status
    errorMessage
  }
}  
`;

export const getDefaultMobileLanguage = gql`query getDefaultMobileLanguage( $appType: String) {
  getDefaultMobileLanguage( appType: $appType) {
    result {
      languageCode
    }
    status
    errorMessage
  }
}  
`;

export const getActiveLanguages = gql`query getActiveLanguages {
 getActiveLanguages {
   results {
     language
     languageCode
   }
   status
   errorMessage
 }
} 
`;